import { getDataMapper, mapField } from "@/shared";

export const mapDepositToServer = getDataMapper({
    title: mapField("title"),
    const: mapField("const", () => "DEPOSIT", { applyToNil: true }), // const required to be not nil
    is_money: mapField("isMoney"),
});
